import { render } from "./ViewCollectionPage.vue?vue&type=template&id=49a2884e&ts=true"
import script from "./ViewCollectionPage.vue?vue&type=script&lang=ts"
export * from "./ViewCollectionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__